import React from 'react';
import { Container, Typography, Box, Grid} from '@mui/material';
import { useNavigate, useOutletContext } from 'react-router-dom';
import PropertyFooterLayout from '../../../components/properties/PropertyFooterLayout';
import SchoolIcon from '@mui/icons-material/School';
import PoolIcon from '@mui/icons-material/Pool';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import ParkingIcon from '@mui/icons-material/LocalParking';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import LandscapeIcon from '@mui/icons-material/Landscape';
import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import ParkIcon from '@mui/icons-material/Park';
import AttractionsIcon from '@mui/icons-material/Attractions';
import FreeBreakfastIcon from '@mui/icons-material/FreeBreakfast';
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';
import CheckroomIcon from '@mui/icons-material/Checkroom';

const progress = 15;
const step = 2;

type PublishOutletContext = {
  handleNavigateToPropertyUploadPhotos: () => void;
  propertyAmenities: string;
  setPropertyAmenities: (propertyAmenities: string) => void;
};


const amenities = [
  { id: 'cerca de la escuela', icon: <SchoolIcon />, label: 'Cerca de la Escuela' },
  { id: 'vista a las montañas', icon: <LandscapeIcon />, label: 'Vista a las Montañas' },
  { id: 'piscina', icon: <PoolIcon />, label: 'Piscina' },
  { id: 'parking de visitas', icon: <ParkingIcon />, label: 'Parking de Visitas' },
  { id: 'seguridad 24 horas', icon: <LocalPoliceIcon/>, label: 'Seguridad 24 Horas' },
  { id: 'jardín o parque', icon: <ParkIcon />, label: 'Jardín o Parque' },
  { id: 'parque infantil', icon: <AttractionsIcon />, label: 'Parque Infantil' },
  { id: 'gimnasio', icon: <FitnessCenterIcon />, label: 'Gimnasio' },
  { id: 'estacionamiento', icon: <ParkingIcon />, label: 'Estacionamiento' },
  { id: 'aire acondicionado', icon: <AcUnitIcon />, label: 'Aire Acondicionado' },
  { id: 'desayunador', icon: <FreeBreakfastIcon />, label: 'Desayunador' },
  { id: 'sala y comedor', icon: <TableRestaurantIcon />, label: 'Sala y Comedor' },
  { id: 'Walk-in-closet', icon: <CheckroomIcon />, label: 'Walk-In-Closet' },

];

const PropertyAmenitiesPage: React.FC = () => {
  const navigate = useNavigate();
  const { handleNavigateToPropertyUploadPhotos, propertyAmenities, setPropertyAmenities } = useOutletContext<PublishOutletContext>();

  const handleSelectionChange = (id: string) => {
    const current = (propertyAmenities)
        .split(',').map(item => item.trim()).filter(item => item.length > 0);

    const newSet = new Set(current);

    if (newSet.has(id)) {
        newSet.delete(id);
    } else {
        newSet.add(id);
    }
    const updatedList = Array.from(newSet).join(', ');

        setPropertyAmenities(updatedList);

};


  const handleBack = () => {
    navigate(-1); 
  };

  const handleContinue = () => {
    handleNavigateToPropertyUploadPhotos();
  };

  return (
    <Container maxWidth="md" sx={{ display: 'flex', pb:10, flexDirection: 'column', minHeight: '110vh', alignItems: 'center' }}>
      <Box mt={4} mb={4} p={4} sx={{ borderRadius: 2, boxShadow: 4, width: '100%' }}>
        <Typography variant="h4" gutterBottom textAlign="center" sx={{mb:4}}>
          Selecciona las Amenidades de la Propiedad
        </Typography>
        {/* Comodidades Section */}
        <Box mb={4}>
          <Grid container spacing={2}>
            {amenities.map(amenity => (
              <Grid item xs={12} sm={6} md={4} key={amenity.id}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    p: 2,
                    borderRadius: 2,
                    boxShadow: 2,
                    cursor: 'pointer',
                    backgroundColor: propertyAmenities.split(', ').includes(amenity.id) ? '#b2dfdb' : 'background.paper',
                    color: propertyAmenities.split(', ').includes(amenity.id) ? 'background.paper' : 'text.primary',
                    transition: 'background-color 0.3s ease, transform 0.2s ease',
                    '&:hover': {
                      transform: 'scale(1.05)',
                      boxShadow: 3,
                    },
                  }}
                  onClick={() => handleSelectionChange(amenity.id)}
                >
                  <Box sx={{ mr: 2 }}>
                    <Typography variant="body1" sx={{ fontSize: '2.5rem' }}>
                      {amenity.icon}
                    </Typography>
                  </Box>
                  <Typography variant="body1" sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
                    {amenity.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>

      <PropertyFooterLayout
        progress={progress}
        step={step}
        onBack={handleBack}
        onContinue={handleContinue}
        isContinueDisabled={false}
      />
    </Container>
  );
};

export default PropertyAmenitiesPage;
